










import Header from '@/components/common/Header.vue';
import Menu from '@/components/common/Menu.vue';
import ReportGenerator from '@/components/billing/ReportGenerator.vue';

export default {
  name: 'Report',
  components: {
    ReportGenerator,
    Header,
    Menu,
  },
};
